<script setup lang="ts">
import { computed } from "vue";
import { useRoute } from "vue-router";
import { activeDataset, datasetSection } from "../datasetNavigation";
const route = useRoute();
const current = computed(() => String(route.query.tab ?? "data"));
const can = (cap: string) =>
  activeDataset.value?.write_state === "active" &&
  activeDataset.value.capabilities.includes(cap);
const groups = computed(() => [
  {
    id: "setup",
    label: "Opsætning",
    tab: can("schema") ? "schema" : can("sources") ? "sources" : "jobs",
  },
  { id: "data", label: "Data", tab: "data" },
  { id: "reports", label: "Dashboards", tab: "dashboard" },
]);
</script>
<template>
  <div
    v-if="activeDataset && route.path === '/datasets/' + activeDataset.id"
    class="dataset-tree"
    :aria-label="'Navigation i ' + activeDataset.name"
  >
    <p class="dataset-tree-name">{{ activeDataset.name }}</p>
    <RouterLink
      v-for="group in groups"
      :key="group.id"
      :to="{ path: route.path, query: { tab: group.tab } }"
      :class="{ active: datasetSection(current) === group.id }"
      :aria-current="datasetSection(current) === group.id ? 'true' : undefined"
    >
      {{ group.label }}
    </RouterLink>
  </div>
</template>
<style
  scoped
  lang="scss"
  src="../styles/components/DatasetDirectory.scss"
></style>
